import { ReactNode } from 'react';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { Flex, TabSelector } from '@coverflex-tech/hypernova';
import { Href, usePathname } from 'expo-router';
import { css } from './RoutedTabs.css';

interface IRoutedTabItemProps {
  label: string;
  path: Href;
  exact?: boolean;
  count?: number;
}

interface IRoutedTabsProps {
  tabs: IRoutedTabItemProps[];
  children: ReactNode;
}

export const RoutedTabs = ({ tabs, children }: IRoutedTabsProps) => {
  const pathname = usePathname();
  return (
    tabs.length > 1 && (
      <Flex flexDirection="column" gap="lg">
        <Flex gap="xl" alignItems="center" className={css.nav}>
          {tabs.map((tab, idx) => (
            <RouterLink key={idx} href={tab.path}>
              <TabSelector
                label={tab.label}
                selected={pathname === tab.path}
                count={tab.count}
              />
            </RouterLink>
          ))}
        </Flex>
        {children}
      </Flex>
    )
  );
};
